import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const DELETE_COMPANY_BENEFITS_INVOICE = gql`
  mutation DeleteCompanyBenefitInvoice($uuid: ID!) {
    deleteCompanyBenefitInvoice(deletedCompanyBenefitInvoice: { uuid: $uuid })
  }
`;

export const useDeleteCompanyBenefitInvoice = () => {
  const [deleteCompanyBenefitInvoiceMutation, { loading, error, data }] = useMutation(DELETE_COMPANY_BENEFITS_INVOICE);

  const deleteCompanyBenefitInvoice = async (uuid) => {
    const response = await deleteCompanyBenefitInvoiceMutation({
      variables: { uuid },
    });
    return response.data.deleteExpenseReport;
  };
  return { deleteCompanyBenefitInvoice, loading, error, data };
};
